window.Popper = require('popper.js').default;

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

    require('flot');
    require('../vendor/flot.time');
    require('../vendor/flot.resize');

} catch (e) {}

// Next we will register the CSRF Token as a common header with jQuery so that
// all outgoing HTTP requests automatically have it attached. This is just
// a simple convenience so we don't have to attach every token manually.
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': token } });
}

